import React from "react";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Lookup,
  FormItem,
  ColumnChooser,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import {
  criarAliquotaIssDs,
  criarDamDs,
  criarAgentesRecebedoresDs,
  criarLancamentoDs,
  criarAlvaraDs,
} from "../../DataSources";
import UserInfo from "../../UserInfo";
import Form, {
  SimpleItem,
  Label,
  ButtonItem,
  EmptyItem,
  GroupItem as GrupoForm,
} from "devextreme-react/form";
import { Button, SelectBox } from "devextreme-react";
import {
  abrirLancamento,
  imprimirAlvara,
  imprimirDam,
  abrirDetalhe,
  abrirLancamentoPorAlvaraView,
  imprimirDamFunction,
  abrirDetalheFuncao,
} from "../../lancamentosUtils";
import PaginaToolbar from "../../components/PaginaToolbar";
import ShowError from "../../AppServices";
import notify from "devextreme/ui/notify";
import api from "../../api-axios";

export default class AlvarasBox extends React.Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.lancamentoDs = criarAlvaraDs();
    this.formatoMoeda = { type: "currency", useGrouping: true, precision: 2 };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.tipoPesquisa = props.tipoPesquisa;
    this.state = {
      filtro: {
        exercicio: undefined,
        codLancamento: undefined,
        tipo: props.tipoPesquisa,
        codContribuinte: undefined,
        codImovel: undefined,
        codCpbs: undefined,
        nomeContribuinte: undefined,
        cpfCnpj: undefined,
        dataInicial: undefined,
        dataFinal: undefined,
        valorInicial: undefined,
        valorFinal: undefined,
        placa: undefined,
      },
    };

    this.statusOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "GERADO" },
        { id: 1, descricao: "PAGO/DISPENSADO" },
        { id: 2, descricao: "EMITIDO" },
        { id: 3, descricao: "CANCELADO" },
        { id: 4, descricao: "SUSPENSO" },
        { id: 5, descricao: "CASSADO" },
        { id: 6, descricao: "EXCLUÍDO" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };

    this.posicaoFiscalOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TRIBUTAVEL" },
        { id: 1, descricao: "IMUNE" },
        { id: 2, descricao: "ISENTO" },
        { id: 4, descricao: "REMISSO" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };

    this.tipoOpcoes = {
      editorType: "dxTagBox",
      selectionMode: "multiple",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "Funcionamento", tipo: "TLLF" },
        { id: 2, descricao: "Transporte", tipo: "TLTA" },
        { id: 3, descricao: "Sanitário", tipo: "TLAS" },
        { id: 4, descricao: "Construção", tipo: "TLAC" },
        { id: 5, descricao: "Habite-se", tipo: "TLHB" },
        { id: 6, descricao: "Horário Especial", tipo: "TLFHE" },
        { id: 7, descricao: "Publicidade", tipo: "TLVP" },
        { id: 8, descricao: "Uso Log. Público", tipo: "TLULP" },
        { id: 9, descricao: "Diversos", tipo: "TLAD" },
      ],
      placeholder: " ",
      valueExpr: "tipo",
      displayExpr: "descricao",
      showClearButton: true,
    };

    this.filtrarOpcoes = {
      type: "success",
      text: "Filtrar",
    };
    this.limparFiltroOpcoes = {
      text: "Limpar",
    };
    this.agentesRecebedoresDs = criarAgentesRecebedoresDs();
    this.agentesRecebedoresOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: criarAgentesRecebedoresDs(),
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: true,
    };
    this.editar = this.editar.bind(this);
  }

  limparFiltro() {
    this.setState({ filtro: {} });
    console.log(this.state);

    this.filtrar();
  }

  filtrar() {
    let filtro = [];
    let estado = this.state.filtro;

    if (estado.exercicio != undefined && estado.exercicio != 0) {
      filtro.push(["exercicio", "=", estado.exercicio]);
    }

    if (estado.placa != undefined) {
      filtro.push(["placa", "contains", estado.placa]);
    }

    if (estado.codLancamento != undefined && estado.codLancamento != 0) {
      filtro.push(["lancamentoSeq", "=", estado.codLancamento]);
    }

    if (estado.codContribuinte != undefined && estado.codContribuinte != 0) {
      filtro.push(["contribuinteSeq", "=", estado.codContribuinte]);
    }

    if (estado.codCpbs != undefined && estado.codCpbs != 0) {
      filtro.push(["inscricaoCpbs", "=", estado.codCpbs]);
    }

    if (estado.codImovel != undefined && estado.codImovel != 0) {
      filtro.push(["imovelSeq", "=", estado.codImovel]);
    }

    if (
      estado.nomeContribuinte != undefined &&
      estado.nomeContribuinte.trim() != ""
    ) {
      filtro.push(["nomeContribuinte", "contains", estado.nomeContribuinte]);
    }

    if (estado.cpfCnpj != undefined && estado.cpfCnpj.trim() != "") {
      filtro.push(["cpfCnpj", "contains", estado.cpfCnpj]);
    }

    if (estado.dataInicial != undefined) {
      const data = estado.dataInicial;
      filtro.push([
        "dataEmissao",
        ">=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          0,
          0,
          0,
          0
        ),
      ]);
    }

    if (estado.dataFinal != undefined) {
      const data = estado.dataFinal;
      filtro.push([
        "dataEmissao",
        "<=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          23,
          5,
          59,
          999
        ),
      ]);
    }

    if (estado.tipo != undefined || this.props.tipoPesquisa != undefined) {
      if (this.props.tipoPesquisa != undefined) {
        filtro.push(["tipo", "=", this.props.tipoPesquisa]);
        console.log("filtro por props", filtro);
      } else {
        if (estado.tipo != undefined && estado.tipo != null && estado.tipo.length > 0) {
          let tipoArray = [];
          estado.tipo.forEach((item) => tipoArray.push(["tipo", "=", item], "or"));
          tipoArray.pop();
          filtro.push(tipoArray);
          console.log(tipoArray);
          console.log("filtro tipo tipo", filtro);
        }
      }
    }

    if (estado.valorInicial != undefined) {
      filtro.push(["imposto", ">=", estado.valorInicial]);
    }

    if (estado.valorFinal != undefined) {
      filtro.push(["imposto", "<=", estado.valorFinal]);
    }

    if (filtro.length > 0) {
      this._gridInstance.instance.filter(filtro);
    } else {
      this._gridInstance.instance.clearFilter();
    }

    this._gridInstance.instance.refresh();
  }

  editar(e) {
    var lancamento = e.row.data;
    abrirLancamentoPorAlvaraView(this.props.history, lancamento);
  }

  componentDidMount() {
    this.setState({ filtro: {} });
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h2 style={{ textAlign: "center" }}>GERENCIADOR DE ALVARÁS</h2>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={6}
            labelLocation="top"
          >
            <SimpleItem
              dataField="exercicio"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Exercício" />
            </SimpleItem>
            <SimpleItem
              dataField="codLancamento"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Cód. Lançamento" />
            </SimpleItem>
            <SimpleItem
              dataField="codContribuinte"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Cód. Contribuinte" />
            </SimpleItem>
            <SimpleItem
              dataField="codImovel"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Imóvel" />
            </SimpleItem>
            <SimpleItem
              dataField="codCpbs"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="CPBS" />
            </SimpleItem>

            <SimpleItem dataField="placa" colSpan={1}>
              <Label text="Placa" />
            </SimpleItem>

            <SimpleItem dataField="nomeContribuinte" colSpan={4}>
              <Label text="Nome Contribuinte" />
            </SimpleItem>

            <SimpleItem dataField="cpfCnpj" colSpan={2}>
              <Label text="CPF/CNPJ" />
            </SimpleItem>

            <SimpleItem
              dataField="dataInicial"
              dataType={"date"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data Inicial" />
            </SimpleItem>

            <SimpleItem
              dataField="dataFinal"
              dataType={"date"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data Final" />
            </SimpleItem>

            <SimpleItem
              dataField="valorInicial"
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtFrmCpbsNumerico"}
            >
              <Label text="Vr. Inicial (R$)" />
            </SimpleItem>

            <SimpleItem
              dataField="valorFinal"
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtFrmCpbsNumerico"}
            >
              <Label text="Vr. Final (R$)" />
            </SimpleItem>

            <SimpleItem
              dataField="tipo"
              colSpan={2}
              editorType={"dxTagBox"}
              editorOptions={this.tipoOpcoes}
              visible={this.tipoPesquisa == undefined}
            >
              <Label text="Tipo de Alvará" />
            </SimpleItem>
          </Form>
          <div style={{ marginTop: "20px", marginBottom: "10px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <PaginaToolbar ocultarNovo={true} titulo={"Lista de Alvarás"}>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.lancamentoDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            focusedRowEnabled={true}
            allowColumnReordering={true}
          >
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              showInfo={true}
            />
            <Column
              dataField={"entidadeId"}
              visible={false}
              showInColumnChooser={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  hint: "DAM",
                  icon: "money",
                  visible: this.onSelecionado == undefined,
                  onClick: (e) => {
                    const data = e.row.data;
                    if (data.status != 0 || data.posicaoFiscal != 0) {
                      notify(
                        "Status ou Posição Fiscal do alvará não permite impressão do DAM.",
                        "error"
                      );
                      return;
                    }
                    imprimirDamFunction(
                      data.prefeituraId,
                      data.lancamentoId,
                      data.chaveLancamento
                    );
                  },
                },
                {
                  hint: "Alvará",
                  icon: "exportpdf",
                  visible: this.onSelecionado == undefined,
                  onClick: (e) => {
                    console.log("e imprimir", e);
                    imprimirAlvara(
                      e.row.data.tipoImpressao,
                      e.row.data.entidadeRef
                    );
                  },
                },
                {
                  hint: "Editar",
                  icon: "edit",
                  visible: this.onSelecionado == undefined,
                  onClick: this.editar,
                },
                {
                  hint: "Info. Lançamento",
                  icon: "more",
                  visible: this.onSelecionado == undefined,
                  onClick: (e) => {
                    const data = e.row.data;

                    if (data.lancamentoSeq == undefined) {
                      notify(
                        "Alvará de migração não pode acessar detalhe de lançamento."
                      );
                      return;
                    }

                    abrirDetalheFuncao(
                      this.props.history,
                      e.row.data.lancamentoSeq
                    );
                  },
                },
                {
                  icon: "repeat",
                  visible: this.onSelecionado != undefined,
                  onClick: this.onSelecionado,
                },
                {
                  hint: "Atualizar CPBS",
                  icon: "repeat",
                  visible: this.onSelecionado == undefined,
                  onClick: async ({ row }) =>
                    await api.post(
                      `/lancamentos/alvara/atualizar_info_cpbs/${row.data.prefeituraId}/${row.data.entidadeRef}`
                    ),
                },
              ]}
            />
            <Column
              dataField={"dataEmissao"}
              caption={"Emissão"}
              dataType={"date"}
              width={100}
              sortIndex={0}
              sortOrder={"desc"}
            />
            <Column
              dataField={"lancamentoSeq"}
              caption={"Lançamento"}
              width={100}
            />
            <Column dataField={"exercicio"} caption={"Exercício"} width={80} />
            <Column dataField={"tipo"} caption={"Tipo"} width={130}>
              <Lookup
                dataSource={this.tipoOpcoes.dataSource}
                displayExpr="descricao"
                valueExpr="tipo"
              />
            </Column>
            <Column dataField={"numero"} caption={"Número"} width={90} />

            <Column
              dataField={"validade"}
              caption={"Validade"}
              dataType={"date"}
              width={100}
            />
            <Column
              dataField={"imovelSeq"}
              caption={"Imóvel"}
              visible={false}
            />
            <Column dataField={"inscricaoCpbs"} caption={"CPBS"} width={100} />
            <Column dataField={"placa"} caption={"Placa"} width={80} />
            <Column dataField={"contribuinteSeq"} caption={"IMC"} width={100} />
            <Column dataField={"nomeContribuinte"} caption={"Responsável"} />
            <Column
              dataField={"vencimento"}
              caption={"Vencimento"}
              dataType={"date"}
              width={100}
            />
            <Column
              dataField={"imposto"}
              caption={"Valor"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Column dataField={"status"} caption={"Status"} width={160}>
              <Lookup
                dataSource={this.statusOptions.dataSource}
                displayExpr={"descricao"}
                valueExpr={"id"}
              />
            </Column>
            <Column
              dataField={"posicaoFiscal"}
              caption={"Pos. Fiscal"}
              width={100}
            >
              <Lookup
                dataSource={this.posicaoFiscalOptions.dataSource}
                displayExpr={"descricao"}
                valueExpr={"id"}
              />
            </Column>
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }
}
